import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import {
  RegisterIntegrationLookup,
  RegisterIntegrationLookupPayload,
} from './register-integration-lookup.types';

/**
 * TIC-4249: qué integrador queda autorizado si el productor se registra con este `referral_source`
 * (p. ej. `nera` desde /go/nera). Endpoint público; sirve para mostrar el disclaimer antes de crear la cuenta.
 */
export async function registerIntegrationLookupService({
  query: referralSource,
}: RegisterIntegrationLookupPayload) {
  const query = transformIntoQueryParamString(encodeURIComponent(referralSource));

  const { response, data } = await BACKEND.get<RegisterIntegrationLookup>(ENDPOINT.REGISTER_INTEGRATIONS, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
